import styles from '../UploadConfigModal.module.scss'
import { UploadConfigFileSelect } from '../UploadConfigFileSelect/UploadConfigFileSelect'
import { UploadConfigDeleteFile } from '../UploadConfigDeleteFile/UploadConfigDeleteFile'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile'

interface UploadConfigFileItemProps {
    idx: number
    fileName: string
    configNames: string[]
    onFileNameSelect: (idx: number, name: string) => void
    onFileDelete: (idx: number) => void
    selectedConfigName: string
}

export const UploadConfigFileItem = (props: UploadConfigFileItemProps) => {
    const {
        idx,
        fileName,
        configNames,
        onFileNameSelect,
        onFileDelete,
        selectedConfigName,
    } = props
    return (
        <div className={styles.fileItem}>
            <div className={styles.fileName}>
                <FontAwesomeIcon
                    icon={faFile}
                    className={`app-color-default ${styles.fileIcon}`}
                />
                <span className='app-color-default'>{fileName}</span>
            </div>

            <div className={styles.fileSelectAndDelete}>
                <UploadConfigFileSelect
                    idx={idx}
                    value={selectedConfigName}
                    optionStrings={configNames}
                    onSelect={onFileNameSelect}
                />
                <UploadConfigDeleteFile
                    idx={idx}
                    onDelete={onFileDelete}
                />
            </div>
        </div>
    )
}
